import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { ApiResponse } from 'api/ApiClient';
import { IAction, IGetPayPeriodsResponse } from 'types';
import * as API from '../../../api';
import * as Actions from './actions';
import { IGetPayPeriodsPayload, PayPeriods } from './types';

export function* getPayPeriods({ payload }: IAction<PayPeriods, IGetPayPeriodsPayload>): any {
  try {
    const { siteId, orgId } = payload;
    const response: ApiResponse<IGetPayPeriodsResponse> = yield call(API.Sites.getPayPeriod, siteId);

    yield put(Actions.getPayPeriodsSuccess({ response: response.body, siteId, orgId }));
  } catch (error: any) {
    yield put(Actions.getPayPeriodsError(error));
  }
}

export function* watchGetPayPeriods() {
  yield takeEvery(PayPeriods.GET_PAY_PERIODS_REQUEST, getPayPeriods);
}

function* payPeriodsSaga() {
  yield all([fork(watchGetPayPeriods)]);
}
export { payPeriodsSaga };
